import api from "./axiosConfig"; // Importa la configuración centralizada de axios

// (2026-05-19) Normalizador de COMPATIBILIDAD del shape de Prefactura tras
// el rename de modelos (mismo criterio que _compatFactura). El backend
// devuelve: comprador (ex cliente_final) en `cliente:{}` + `cliente_id`;
// emisor sólo como `empresa_id`; afiliada/tercero en `tercero:{}`;
// pago.metodo_pago:{}. Se re-exponen alias legacy (snapshot plano cliente_*
// desde nested `cliente`, afiliada en `empresa` desde `tercero`). Defensivo.
const _compatPrefactura = (f) => {
  if (!f || typeof f !== "object") return f;
  if (f.tercero && !f.empresa) f.empresa = f.tercero;
  const cf = f.cliente;
  if (cf && typeof cf === "object") {
    if (f.cliente_nombre == null) f.cliente_nombre = cf.nombre;
    if (f.cliente_rif == null) f.cliente_rif = cf.rif;
    if (f.cliente_direccion == null) f.cliente_direccion = cf.direccion;
    if (f.cliente_telefono == null) f.cliente_telefono = cf.telefono;
    if (f.cliente_email == null) f.cliente_email = cf.email;
    if (f.cliente_tipo == null) f.cliente_tipo = cf.tipo;
    if (f.cliente_tipo_doc_identidad == null)
      f.cliente_tipo_doc_identidad = cf.tipo_doc_identidad;
  }
  if (Array.isArray(f.pagos)) {
    f.pagos.forEach((p) => {
      if (p && p.metodo_pago && typeof p.metodo_pago === "object") {
        if (p.metodo_pago_nombre == null) p.metodo_pago_nombre = p.metodo_pago.nombre;
        if (p.metodo_pago_codigo == null) p.metodo_pago_codigo = p.metodo_pago.codigo;
      }
    });
  }
  return f;
};

const _compatPrefacturaResp = (data) => {
  try {
    if (Array.isArray(data)) { data.forEach(_compatPrefactura); return data; }
    if (data && Array.isArray(data.data)) { data.data.forEach(_compatPrefactura); return data; }
    if (data && Array.isArray(data.resultados)) { data.resultados.forEach(_compatPrefactura); return data; }
  } catch (_e) { /* noop */ }
  return data;
};

// Obtener todos los pre-facturas
export const getPreInvoices = async (params = {}) => {
  try {
    const authData = localStorage.getItem("authData");
    const { page = 1, per_page = 20 } = params;

    if (!authData) return;

    const { rol } = JSON.parse(authData);

    const endpoint = (rol === 'admin' || rol == "auditor")
      ? '/admin/pre-invoices'
      : '/api/pre-invoices/';

    // (2026-05-15) Pass-through de todos los filtros. El whitelist anterior
    // descartaba doc_tercero, tercero_id y solo_comision -> esos filtros no
    // buscaban en Proformas. El backend ignora params no soportados.
    const query = new URLSearchParams({ page, per_page });
    Object.entries(params).forEach(([k, v]) => {
      if (k === 'page' || k === 'per_page') return;
      if (v === null || v === undefined || v === '') return;
      query.append(k, v);
    });

    const response = await api.get(`${endpoint}?${query.toString()}`);
    return _compatPrefacturaResp(response.data); // {data, total, total_pages}
    /*if (authData) {
      const { rol } = JSON.parse(authData);
      var response;
      if (rol == 'admin'){
        response = await api.get(`/admin/pre-invoices?page=${page}&per_page=${per_page}`);
      }else{
        response = await api.get(`/api/pre-invoices?page=${page}&per_page=${per_page}`);
      }
      return _compatPrefacturaResp(response.data).data; // Devuelve los datos de los pre-facturas
    }*/
  } catch (error) {
    console.error("Error al obtener las pre-facturas:", error);
    throw error;
  }
};

// Consultar un pre-facturas por ID
export const showPreInvoice = async (id) => {
  try {
    const authData = localStorage.getItem("authData");
    if (authData) {
      const { rol } = JSON.parse(authData);
      var response;
      if (rol == 'admin' || rol == "auditor"){
        response = await api.get(`/admin/pre-invoices/${id}`);
        //response = await api.get(`/pre-invoices/${id}`);
      }else{
        response = await api.get(`/api/pre-invoices/${id}`);
      }
      return _compatPrefactura(response.data);
    }
  } catch (error) {
    console.error("Error al consultar el pre-facturas:", error);
    throw error;
  }
};

// Convertir en factura
export const convertInInvoice = async (body) => {
  try {
    const response = await api.post(`/api/invoices/from-pre-invoice`, body);
    //console.log('convertInInvoice-response: ', response);
    return response.data;
  } catch (error) {
    console.error("Error al Convertir en factura:", error);
    throw error;
  }
};

// Editar un pre-facturas
export const editPreInvoice = async (id, body) => {
  try {
    const authData = localStorage.getItem("authData");
    var items;
    if (authData) {
      const { rol } = JSON.parse(authData);
      var response;
      var response_i;
      if (rol == 'admin'){
        response = await api.get(`/admin/pre-invoices/${id}`);
        //response = await api.get(`/pre-invoices/${id}`);
      }else{
        items = body.items;
        /*console.log('body: ', body);
        console.log('items: ', items);*/
        delete body.items;
        response = await api.put(`/api/pre-invoices/${id}`, body);
        for (var i = 0; i < items.length; i++){
          if (items[i].nueva_linea == true){
            delete items[i].id;
          }
        }
        //console.log('items(F): ', items);
        response_i = await api.put(`/api/pre-invoices/${id}/items:bulk_upsert`, items);
        console.log('response_i: ', response_i);
      }
      return _compatPrefactura(response.data);
    }
  } catch (error) {
    console.error("Error al editar el pre-facturas:", error);
    //throw error;
    body.items = items;
    return error.response.data;
  }
};

// Crear un pre-facturas
export const createPreInvoice = async (body, client_id=false) => {
  try {
    var response;
    if (client_id == false){
      response = await api.post(`/api/invoices`, body);
    }else{
      //console.log('createPreInvoice-response: ', `/admin/empresas/${client_id}/pre-invoices`);
      response = await api.post(`/admin/empresas/${client_id}/pre-invoices`, body);
    }
    console.log('createPreInvoice-response: ', response);
    return response.data;
  } catch (error) {
    console.error("Error al crear el pre-facturas:", error);
    return response;
  }
};

// Eliminar un pre-facturas
export const deletePreInvoice = async (id) => {
  try {
    const response = await api.delete(`/pre-invoices/${id}`);
    console.log('deletePreInvoice-response: ', response);
    return response.data;
  } catch (error) {
    console.error("Error al eliminar el pre-facturas:", error);
    throw error;
  }
};